import { Point } from '../core/point'

export interface IMazeGameLevel {
    board: number[][]
    size: Point
    player: Point
    target: Point
    water?: Point[]
    hole?: Point[]
    verticalFence?: Point[]
    horizontalFence?: Point[]
}

export interface IMazeGameWall {
    top: boolean
    right: boolean
    bottom: boolean
    left: boolean
}

function p(x: number, y: number) {
    return Point.xy(x, y)
}

const TOP_WALL = 0x0001;
const LEFT_WALL = 0x0010;
const BOTTOM_WALL = 0x0100;
const RIGHT_WALL = 0x1000;


export function toWall(x: number) {
    const top = (x & TOP_WALL) > 0
    const right = (x & RIGHT_WALL) > 0
    const bottom = (x & BOTTOM_WALL) > 0
    const left = (x & LEFT_WALL) > 0

    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
    }

}

export function getMazeGameLevels(): IMazeGameLevel[] {

    return [
        {
            // 1
            board: [
                [0, 1, 0, 0, 0, 1],
                [0, 1, 0, 1, 0, 1],
                [0, 0, 0, 1, 0, 0],
                [0, 1, 0, 1, 1, 0],
                [0, 1, 0, 0, 1, 0],
                [0, 1, 1, 1, 1, 0]
            ],
            size: p(6, 6),
            player: p(0, 0),
            target: p(5, 5),
        },
        {
            // 2
            board: [
                [0, 0, 0, 1, 1, 1],
                [0, 1, 0, 0, 0, 0],
                [0, 0, 1, 1, 1, 0],
                [1, 0, 1, 0, 1, 0],
                [1, 0, 1, 0, 1, 0],
                [1, 0, 1, 0, 0, 0]
            ],
            size: p(6, 6),
            player: p(0, 0),
            target: p(3, 3),
        },
        {
            board: [
                [0, 0, 0, 0, 0, 1],
                [1, 1, 0, 1, 0, 0],
                [1, 1, 0, 1, 1, 0],
                [1, 0, 0, 1, 0, 1],
                [1, 0, 1, 1, 0, 1],
                [1, 0, 0, 0, 0, 0]
            ],
            size: p(6, 6),
            player: p(0, 0),
            target: p(4, 3),
        },
        {
            // 2
            board: [
                [0, 1, 0, 0, 0, 0, 0, 0],
                [0, 1, 0, 1, 0, 1, 1, 0],
                [0, 0, 0, 1, 0, 0, 1, 0],
                [1, 1, 1, 1, 0, 1, 1, 0],
                [0, 0, 0, 0, 0, 0, 1, 0],
                [0, 1, 1, 1, 1, 1, 1, 1],
                [0, 0, 1, 0, 0, 0, 1, 1],
                [1, 0, 0, 0, 1, 0, 0, 0],
            ],
            size: p(8, 8),
            player: p(0, 0),
            target: p(7, 7),
        },
        {
            // 2
            board: [
                [0, 1, 0, 0, 0, 0, 0, 0],
                [0, 1, 0, 1, 1, 1, 1, 0],
                [0, 0, 0, 1, 0, 0, 1, 0],
                [0, 1, 0, 1, 0, 1, 1, 0],
                [0, 1, 1, 1, 0, 1, 0, 1],
                [0, 1, 0, 1, 0, 0, 0, 1],
                [0, 0, 0, 1, 0, 1, 0, 1],
                [0, 1, 0, 0, 0, 0, 0, 0]
            ],
            size: p(8, 8),
            player: p(0, 0),
            target: p(5, 2),
        },
        {
            // 2
            board: [
                [0, 1, 0, 0, 0, 0, 0, 0],
                [0, 1, 1, 0, 1, 1, 1, 0],
                [0, 0, 0, 0, 0, 0, 1, 0],
                [0, 1, 1, 1, 1, 0, 1, 0],
                [0, 1, 0, 0, 1, 0, 1, 0],
                [0, 1, 1, 0, 0, 0, 1, 0],
                [0, 1, 0, 1, 1, 0, 1, 1],
                [0, 0, 0, 1, 1, 0, 0, 0]
            ],
            size: p(8, 8),
            player: p(0, 0),
            target: p(2, 4),
        },

    ]
}


export function getMazeV2GameLevels(): IMazeGameLevel[] {
    return [
        {
            // 1
            board: [
                [TOP_WALL | LEFT_WALL, TOP_WALL, TOP_WALL, TOP_WALL, TOP_WALL, TOP_WALL, TOP_WALL, TOP_WALL | RIGHT_WALL],
                [LEFT_WALL, LEFT_WALL | RIGHT_WALL, 0, LEFT_WALL | RIGHT_WALL, LEFT_WALL | RIGHT_WALL, 0, LEFT_WALL, RIGHT_WALL],
                [LEFT_WALL, TOP_WALL | BOTTOM_WALL, LEFT_WALL, TOP_WALL | RIGHT_WALL, LEFT_WALL, LEFT_WALL, LEFT_WALL, RIGHT_WALL],
                [LEFT_WALL, RIGHT_WALL, LEFT_WALL, 0, LEFT_WALL | RIGHT_WALL, LEFT_WALL | RIGHT_WALL, LEFT_WALL, RIGHT_WALL],
                [LEFT_WALL, LEFT_WALL, LEFT_WALL, TOP_WALL | LEFT_WALL, TOP_WALL | RIGHT_WALL, LEFT_WALL, LEFT_WALL, RIGHT_WALL],
                [LEFT_WALL, 0, LEFT_WALL | RIGHT_WALL, TOP_WALL, RIGHT_WALL, LEFT_WALL | RIGHT_WALL, LEFT_WALL, RIGHT_WALL],
                [LEFT_WALL, LEFT_WALL, BOTTOM_WALL, TOP_WALL | LEFT_WALL, RIGHT_WALL, LEFT_WALL, LEFT_WALL, RIGHT_WALL],
                [BOTTOM_WALL | LEFT_WALL, BOTTOM_WALL, BOTTOM_WALL, BOTTOM_WALL, BOTTOM_WALL, BOTTOM_WALL, BOTTOM_WALL, BOTTOM_WALL | RIGHT_WALL]
            ],
            size: p(8, 8),
            player: p(0, 0),
            target: p(7, 7),
            water: [
                p(1, 0),
                p(2, 0),
                p(0, 1),
                p(1, 1),
                p(2, 1),
                p(3, 1),
                p(0, 2),
                p(1, 2),
                p(2, 2),
                p(3, 2),
                p(1, 3),
                p(2, 3)
            ],
            hole: [p(3, 0), p(0, 0), p(3, 3), p(0, 3)]
        },
    ]
}
